var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26.7107 4.515C26.7107 4.515 26.4214 2.415 25.65 1.575C24.5893 0.42 23.4321 0.42 22.95 0.315C19.1893 1.87755e-07 13.5 0 13.5 0C13.5 0 7.81071 1.87755e-07 4.05 0.315C3.47143 0.42 2.41071 0.42 1.35 1.575C0.578571 2.52 0.289286 4.515 0.289286 4.515C0.289286 4.515 0 6.93 0 9.345V11.655C0 14.07 0.289286 16.485 0.289286 16.485C0.289286 16.485 0.578571 18.585 1.35 19.425C2.41071 20.58 3.76071 20.58 4.33929 20.685C6.46071 20.895 13.5 21 13.5 21C13.5 21 19.1893 21 22.95 20.685C23.4321 20.58 24.5893 20.58 25.65 19.425C26.4214 18.48 26.7107 16.485 26.7107 16.485C26.7107 16.485 27 14.07 27 11.655V9.345C27 6.93 26.7107 4.515 26.7107 4.515ZM10.7036 14.385V5.985L18.0321 10.185L10.7036 14.385Z","fill":"#3A2A55"}));
}

Youtube.defaultProps = {"width":"27","height":"21","viewBox":"0 0 27 21","fill":"none"};

module.exports = Youtube;

Youtube.default = Youtube;
